<modal-form-container
  title="Add tags"
  className="md:w-[720px] lg:w-[760px]"
  [showModal]="open"
  (closeModalEvent)="closeModal()"
>
  @if (open) {
    <div class="gm">
      <p class="gm__lead">
        The <strong>{{ rowLabel }}</strong> you picked get these tags when the import is saved. Search for a tag, or
        create one if it does not exist yet.
      </p>

      <bk-group-picker kind="tag" [allowCreate]="true" [selected]="selectedTags" (selectedChange)="onPick($event)" />

      <div class="gm__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [disabled]="!selectedTags.length"
          (click)="handleSubmit()"
        >
          {{ submitLabel }}
        </button>
      </div>
    </div>
  }
</modal-form-container>
